import { Section } from "@/components/Section";
import { Container } from "@/components/Container";
import { Eyebrow } from "@/components/Eyebrow";
import { Reveal } from "@/components/Reveal";

const STEPS = [
  {
    n: "1",
    title: "Free 20-minute call.",
    body: "We learn what you do and where it hurts. You get an honest read on whether AI helps your situation. If it doesn't, we'll tell you.",
  },
  {
    n: "2",
    title: "Opportunity assessment.",
    body: "We map how your business runs and rank where AI can unlock value — impact, effort, and time to payback for each one. You own the output whether or not you hire us to build it.",
  },
  {
    n: "3",
    title: "Build.",
    body: "We implement the highest-value opportunity first, integrated with the systems you already run. Working software, not a prototype.",
  },
  {
    n: "4",
    title: "Adoption.",
    body: "Training, documentation, and follow-through until the new way is just the way your team works.",
  },
] as const;

export function Process() {
  return (
    <Section tone="paper">
      <Container>
        <Reveal className="max-w-[52ch]">
          <Eyebrow>How an engagement runs</Eyebrow>
          <h2 className="mt-3 font-display text-h2 text-ink-900">
            Four steps, and you can stop after any of them.
          </h2>
        </Reveal>

        <div className="relative mt-12">
          {/* Mobile: vertical rail down the left, through circle centres. */}
          <div
            aria-hidden="true"
            className="pointer-events-none absolute left-6 top-6 bottom-6 w-px min-[900px]:hidden"
            style={{
              backgroundColor: "color-mix(in oklab, var(--brand-600) 35%, transparent)",
            }}
          />
          {/* Desktop: horizontal rail across the row, through circle centres. */}
          <div
            aria-hidden="true"
            className="pointer-events-none absolute top-6 left-[12.5%] right-[12.5%] hidden h-px min-[900px]:block"
            style={{
              backgroundColor: "color-mix(in oklab, var(--brand-600) 35%, transparent)",
            }}
          />

          <ol className="grid grid-cols-1 gap-10 min-[900px]:grid-cols-4 min-[900px]:gap-8">
            {STEPS.map((step, i) => (
              <Reveal key={step.n} delay={i * 60} className="flex gap-5 min-[900px]:block">
                <div className="flex shrink-0 justify-start min-[900px]:justify-center">
                  <span className="relative z-10 flex size-12 items-center justify-center rounded-full border-2 border-brand-600 bg-paper-50 font-mono text-body font-semibold text-brand-700">
                    {step.n}
                  </span>
                </div>
                <div className="min-[900px]:mt-6">
                  <h3 className="font-display text-h3 text-ink-900">{step.title}</h3>
                  <p className="mt-2 text-body text-ink-600">{step.body}</p>
                </div>
              </Reveal>
            ))}
          </ol>
        </div>
      </Container>
    </Section>
  );
}

export default Process;
